module.exports = {
  emptyMessage: 'Faltó llenar este campo. Llénalo con el nombre que aparece en tu tarjeta.',
  containsNumberMessage: '¡Ey!, el nombre no puede contener números.',
  maxLengthMessage: '¡Ups!, excediste el número de caracteres permitidos, inténtalo nuevamente.',
  defaultMessage: '¡Ups! El nombre que informaste es inválido.',
};
